function omit(obj, fields) {
  // eslint-disable-next-line prefer-object-spread
  var shallowCopy = Object.assign({}, obj);

  for (var i = 0; i < fields.length; i += 1) {
    var key = fields[i];
    delete shallowCopy[key];
  }

  return shallowCopy;
}

export default omit;


//////////////////
// WEBPACK FOOTER
// ./node_modules/omit.js/es/index.js
// module id = 34
// module chunks = 0